import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import { Toolbar } from './toolbar/Toolbar'
import { OnDemand } from './OnDemand'
import { AGENT_TYPE } from './../actions/agent'

import '../styles/app.scss'
import 'simplebar/dist/simplebar.min.css'

const AppContainerComponent = ({ agentType }) => {
  return (
    <React.Fragment>
      <div className='appContainer'>
        <div className='sideBar'>
          <div className={`topLogo ${(agentType === AGENT_TYPE.CLASSROOM_AGENT) ? 'classroom' : ''}`}>
          </div>
          <div className='toolbarArea'>
            <Toolbar />
          </div>
        </div>
        <div className='onDemandContainer'>
          <OnDemand />
        </div>
      </div>
    </React.Fragment>
  )
}

AppContainerComponent.propTypes = {
  agentType: PropTypes.string.isRequired
}

const mapStateToProps = (state) => ({
  agentType: state.agent.type,
})

const AppContainer = connect(mapStateToProps)(AppContainerComponent)

export { AppContainer }

